import {ValueDefinition} from '@/model/types';

export const DV_95 = {
  id: 'DV-95',
  description: {
    fr: 'Fonds de placement garanti',
    en: 'Guaranteed Investment Funds',
  },
  type: 'InvestmentAccount',
  values: [
    {
      id: '02',
      value: {fr: 'Marché monétaire Fiera Capital', en: 'Fiera Capital Money Market'},
      properties: {
        id_beneva: '036',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2'],
          'B': ['DV-96#2'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '03',
      value: {fr: 'Obligations court terme Fiera Capital', en: 'Fiera Capital Short Term Bond'},
      properties: {
        id_beneva: '104',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '04',
      value: {fr: 'Obligations Fiera Capital', en: 'Fiera Capital Bond'},
      properties: {
        id_beneva: '119',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '05',
      value: {fr: 'Obligations PIMCO', en: 'PIMCO Bond'},
      properties: {
        id_beneva: '096',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '06',
      value: {fr: 'Obligations et prêts bancaires AlphaFixe', en: 'AlphaFixe Bond and Bank Loan'},
      properties: {
        id_beneva: '169',
        DtDb: '2012-11-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '07',
      value: {fr: 'Obligations mondiales PIMCO', en: 'PIMCO Global Bond'},
      properties: {
        id_beneva: '152',
        DtDb: '2012-11-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '09',
      value: {fr: 'Obligations de sociétés Ci', en: 'CI Corporate Bond'},
      properties: {
        id_beneva: '165',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '10',
      value: {fr: 'Indice obligataire BlackRock', en: 'BlackRock Bond Index'},
      properties: {
        id_beneva: '049',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '11',
      value: {fr: 'Portefeuille bêta intelligent plus – sécuritaire', en: 'Conservative Smart Beta Plus Portfolio'},
      properties: {
        id_beneva: '175',
        DtDb: '2012-11-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '12',
      value: {fr: 'Portefeuille bêta intelligent plus – équilibré', en: 'Balanced Smart Beta Plus Portfolio'},
      properties: {
        id_beneva: '176',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '13',
      value: {fr: 'Portefeuille bêta intelligent plus – croissance', en: 'Growth Smart Beta Plus Portfolio'},
      properties: {
        id_beneva: '177',
        DtDb: '2011-10-10',
        DtEx: '2199-01-01',
        DtFi: '2199-01-01',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '14',
      value: {fr: 'Portefeuille bêta intelligent plus – audacieux', en: 'Aggressive Smart Beta Plus Portfolio '},
      properties: {
        id_beneva: '178',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '15',
      value: {fr: 'Stratégie sécuritaire', en: 'Conservative Strategy'},
      properties: {
        id_beneva: '044',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '18',
      value: {fr: 'Stratégie équilibrée', en: 'Balanced Strategy'},
      properties: {
        id_beneva: '035',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '20',
      value: {fr: 'Stratégie croissance', en: 'Growth Strategy'},
      properties: {
        id_beneva: '045',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '21',
      value: {fr: 'Stratégie audacieuse', en: 'Aggressive Strategy'},
      properties: {
        id_beneva: '024',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '22',
      value: {fr: 'Stratégie 100 % actions', en: '100% Equity Strategy'},
      properties: {
        id_beneva: '188',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '23',
      value: {fr: 'Celestia sécuritaire', en: 'Celestia Conservative'},
      properties: {
        id_beneva: '100',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '24',
      value: {fr: 'Celestia équilibré', en: 'Celestia Balanced'},
      properties: {
        id_beneva: '101',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '25',
      value: {fr: 'Celestia croissance', en: 'Celestia Growth'},
      properties: {
        id_beneva: '102',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '26',
      value: {fr: 'Celestia audacieux', en: 'Celestia Aggressive'},
      properties: {
        id_beneva: '103',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '27',
      value: {fr: 'Celestia 100 % actions', en: 'Celestia 100% Equity'},
      properties: {
        id_beneva: '189',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '28',
      value: {fr: 'Revenu sécuritaire Guardian', en: 'Guardian Conservative Income'},
      properties: {
        id_beneva: '156',
        DtDb: '2013-12-09',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '29',
      value: {fr: 'Revenu Guardian', en: 'Guardian Income'},
      properties: {
        id_beneva: '157',
        DtDb: '2013-12-09',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '30',
      value: {fr: 'Répartition d’actifs canadiens CI', en: 'CI Canadian Asset Allocation'},
      properties: {
        id_beneva: '153',
        DtDb: '2013-12-09',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '31',
      value: {fr: 'Revenu et croissance mondial CI ', en: 'CI Global Income and Growth'},
      properties: {
        id_beneva: '154',
        DtDb: '2013-12-09',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '32',
      value: {fr: 'Actions canadiennes dividendes Guardian', en: 'Guardian Canadian Dividend Equity'},
      properties: {
        id_beneva: '148',
        DtDb: '2013-12-09',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '33',
      value: {fr: 'Actions canadiennes Jarislowsky Fraser', en: 'Jarislowsky Fraser Ltd Canadian Equity'},
      properties: {
        id_beneva: '012',
        DtDb: '2015-04-14',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '34',
      value: {fr: 'Actions canadiennes Triasima', en: 'Triasima Canadian Equity'},
      properties: {
        id_beneva: '085',
        DtDb: '2015-11-30',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '35',
      value: {fr: 'Indice canadien BlackRock', en: 'BlackRock Canadian Index'},
      properties: {
        id_beneva: '046',
        DtDb: '2015-11-30',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '36',
      value: {
        fr: 'Actions canadiennes à petite capitalisation Fiera Capital',
        en: 'Fiera Capital Canadian Small Cap Equity ',
      },
      properties: {
        id_beneva: '015',
        DtDb: '2015-11-30',
        DtEx: '2026-03-16',
        DtFi: '2026-03-16',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '53',
      value: {
        fr: 'Actions canadiennes à petite capitalisation Beutel Goodman',
        en: 'Beutel Goodman Small Cap Canadian Equity',
      },
      properties: {
        id_beneva: '015',
        DtDb: '2026-03-17',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '37',
      value: {fr: 'Actions américaines Hillsdale', en: 'Hillsdale U.S. Equity'},
      properties: {
        id_beneva: '147',
        DtDb: '2016-01-18',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '38',
      value: {fr: 'Actions américaines Beutel Goodman', en: 'Beutel Goodman U.S. Equity'},
      properties: {
        id_beneva: '163',
        DtDb: '2016-05-16',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '39',
      value: {fr: 'Actions américaines Fiera Capital', en: 'Fiera Capital U.S. Equity'},
      properties: {
        id_beneva: '162',
        DtDb: '2016-05-16',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '40',
      value: {fr: 'Actions américaines couvertes sur la devise Fiera Capital', en: 'Fiera Capital Hedged U.S. Equity'},
      properties: {
        id_beneva: '166',
        DtDb: '2016-12-05',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '41',
      value: {fr: 'Indice américain BlackRock', en: 'BlackRock U.S. Index'},
      properties: {
        id_beneva: '047',
        DtDb: '2016-12-05',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '42',
      value: {fr: 'Actions américaines à petite capitalisation ESG Fisher', en: 'Fisher ESG U.S. Small Cap Equity'},
      properties: {
        id_beneva: '187',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '43',
      value: {fr: 'Actions internationales GQG partners', en: 'GQG Partners International Equity'},
      properties: {
        id_beneva: '183',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '44',
      value: {fr: 'Actions internationales C WorldWide', en: 'C WorldWide International Equity'},
      properties: {
        id_beneva: '097',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '45',
      value: {fr: 'Indice international BlackRock', en: 'BlackRock International Index'},
      properties: {
        id_beneva: '050',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '46',
      value: {fr: 'Actions mondiales dividendes TD', en: 'TD Global Dividend Equity'},
      properties: {
        id_beneva: '150',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '47',
      value: {fr: 'Actions mondiales Fiera Capital', en: 'Fiera Capital Global Equity'},
      properties: {
        id_beneva: '164',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6', 'DV-88#7', 'DV-88#8'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'D': ['DV-96#1'],
          'E': ['DV-96#1'],
        },
      },
    },
    {
      id: '48',
      value: {fr: 'Actions mondiales GQG Partners', en: 'GQG Partners Global Equity'},
      properties: {
        id_beneva: '182',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '49',
      value: {fr: 'Actions mondiales à petite capitalisation Fisher', en: 'Fisher Global Small Cap Equity'},
      properties: {
        id_beneva: '174',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '50',
      value: {fr: 'Actions marchés émergents Fisher ', en: 'Fisher Emerging Markets Equity '},
      properties: {
        id_beneva: '139',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#4', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'C': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          'C': ['DV-96#2'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '51',
      value: {fr: 'Infrastructures mondiales Lazard', en: 'Lazard Global Infrastructure'},
      properties: {
        id_beneva: '090',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
    {
      id: '52',
      value: {fr: 'Immobilier mondial CI', en: '100% CI Global Real Estate'},
      properties: {
        id_beneva: '190',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
        dv88: ['DV-88#2', 'DV-88#3', 'DV-88#5', 'DV-88#6'],
        dv96_legacy: {
          'A': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          'B': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
        dv96: {
          'A': ['DV-96#2', 'DV-96#4'],
          'B': ['DV-96#2', 'DV-96#4'],
          '3': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
          '4': ['DV-96#1', 'DV-96#2', 'DV-96#3', 'DV-96#4'],
        },
      },
    },
  ],
} satisfies ValueDefinition;
